import React from 'react';
import classNames from 'classnames';
import { Grid } from 'semantic-ui-react';
import LookUpMenu from 'PointOfSale/modules/lookup/component/LookUpMenu';
import LookUpResultTable from 'PointOfSale/modules/lookup/component/LookUpResultTable';
import LookUpResultHeaderTable from 'PointOfSale/modules/lookup/component/LookUpResultHeaderTable';
import _ from 'lodash';
import ScrollContainer from 'PointOfSale/modules/common/container/ScrollContainer';
import PropTypes from 'prop-types';
import PortalOverlay from 'PointOfSale/modules/common/component/PortalOverlay';
import { SessionTypes } from 'PointOfSale/modules/common/constants';

const TITLE = {
  [SessionTypes.Queue]: 'Student',
  [SessionTypes.Teacher]: 'Teacher',
};

const LookUp = ({
  onSearchChange,
  searchTerm,
  searchResults,
  onLookupClose,
  showLoading,
  visitingStudents,
  toggleVisitingStudentStatus,
  onItemSelect,
  activeSession,
  showLookUp,
  onLookUpInputFocus,
  onLookUpInputBlur,
  padScrollBottom,
  message,
}) => {
  const getSearchResultsMessage = () => {
    return searchResults.length > 0
      ? `${searchResults.length} ${TITLE[activeSession]}${
          searchResults.length === 1 ? '' : 's'
        } found`
      : '';
  };
  return (
    <React.Fragment>
      <div className="flex-1 flex flex-col flex-no-wrap">
        <LookUpMenu
          onSearchChange={onSearchChange}
          searchTerm={searchTerm}
          showLoading={showLoading}
          toggleVisitingStudentStatus={toggleVisitingStudentStatus}
          visitingStudents={visitingStudents}
          activeSession={activeSession}
          onLookUpInputFocus={onLookUpInputFocus}
          onLookUpInputBlur={onLookUpInputBlur}
          onLookupClose={onLookupClose}
        />

        <Grid padded="horizontally">
          {_.isEmpty(searchResults) ? (
            <Grid.Row>
              <Grid.Column className="text-primary">
                No Search Results
              </Grid.Column>
            </Grid.Row>
          ) : (
            <React.Fragment>
              <Grid.Row>
                <Grid.Column className="text-primary">
                  <p>{getSearchResultsMessage()}</p>
                  {message && <p>{message}</p>}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <LookUpResultHeaderTable activeSession={activeSession} />
                </Grid.Column>
              </Grid.Row>
            </React.Fragment>
          )}
        </Grid>
        <ScrollContainer
          paging
          enableScrollButtons
          className={classNames('flex-1', {
            'pos-scroll-grid-keyboard-visible': padScrollBottom,
          })}
        >
          <LookUpResultTable
            activeSession={activeSession}
            profiles={searchResults}
            onItemSelect={onItemSelect}
          />
        </ScrollContainer>
      </div>
      {showLookUp && (
        <PortalOverlay
          modalRoot={document.getElementById('side-bar-container-id')}
          divClassName={'lookUpOpacity'}
        />
      )}
    </React.Fragment>
  );
};

LookUp.propTypes = {
  onSearchChange: PropTypes.func,
  toggleVisitingStudentStatus: PropTypes.func,
  searchTerm: PropTypes.string,
  searchResults: PropTypes.array,
  onLookupClose: PropTypes.func,
  showLoading: PropTypes.bool,
  activeSession: PropTypes.string,
  onItemSelect: PropTypes.func,
  showLookUp: PropTypes.bool,
  message: PropTypes.string,
};

export default LookUp;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/component/LookUp.js